import { render, staticRenderFns } from "./PatientRow.vue?vue&type=template&id=6505ffee"
import script from "./PatientRow.vue?vue&type=script&lang=js"
export * from "./PatientRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports